

































import { computed, defineComponent, PropType, ref, toRefs } from '@vue/composition-api';
import TooltipInfo from '@/components/common/tooltip-info/index.vue';
import PriceSuggestIcon from '@tt4b/ttam-assets/src/svgs/price-suggest-icon.svg';
import { CurrencyOption } from './../../../../hooks/creation/account/useCurrencyOption/index';
import { trackEvent } from './../../../../utils/index';
import { BidcapSuggestBidData } from '../types';

const name = 'ttam-bid-strategy-bidcap-suggest-bid';

export default defineComponent({
  name,
  components: { TooltipInfo, PriceSuggestIcon },
  props: {
    data: {
      type: Object as PropType<BidcapSuggestBidData>,
      required: true,
    },
    currencyOption: {
      type: Object as PropType<CurrencyOption>,
      default: () => ({}),
    },
  },

  setup(props, { emit }) {
    const { data } = toRefs(props);
    const suggestBid = computed(() => data.value?.suggestBidStr);

    const currency = computed(() => props.currencyOption?.currency || '');
    const onApplyBidcapSuggestedBid = () => {
      if (data.value?.suggestBidNum > 0) {
        trackEvent('bidcap_suggest_bid_apply');
        emit('apply');
      }
    };

    /** suggested bid 卡片内容渲染埋点 */
    const trackSuggestedBidCardRener = () => {
      trackEvent('bidcap_suggest_bid_card_render', { margin: data.value?.margin });
    };

    return {
      name,
      currency,
      suggestBid,
      onApplyBidcapSuggestedBid,
      trackSuggestedBidCardRener,
    };
  },
});
